// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Textbook_wrapper__3FgBq"};